import { FramelessShell } from '@/components/Layout/Application/Frameless/FramelessShell';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_frameless')({
  component: FramelessShell,
  beforeLoad: ({ context, location }) => {
    if (!context.auth.authenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }
  },
});
